import { FC } from "react";
import { Navigate, useSearchParams } from "react-router";

export const NavigateWithQueryParams: FC<{ to: string; replace?: boolean }> = ({ to, replace }) => {
	const [searchParams] = useSearchParams();

	return <Navigate to={`${to}?${searchParams.toString()}`} replace={replace} />;
};
